export const EDUCATION_ROUTES = {
  get: '/education',
  post: '/education',
  patch: '/education/{id}',
  delete: '/education/{id}',
};

export const TRAINING_ROUTES = {
  get: '/training',
  post: '/training',
  patch: '/training/{id}',
  delete: '/training/{id}',
};

export const EDUCATION_DETAILS_ROUTES = {
  delete: '/education-details/{id}',
};

export const INSTITUTIONS_ROUTES = {
  get: '/institutions/search',
};
